import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// Helpers
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: colors.green.darken1, // #E53935
        secondary: colors.lime.lighten2, // #FFCDD2
        accent: colors.indigo.base // #3F51B5
      }
    }
  }
})
